<template>
  <div class="home">
    <h1 class="blue-grey--text my-5 text-center">총 {{ items.length }} 항목</h1>
    <v-container>
      <!-- serch box -->
      <v-row justify="end">
          <v-col
            cols="12"
            sm="6"
          >
              <v-text-field
                  label="Search"
                  v-model="search"
                  prepend-inner-icon="mdi-magnify"
              ></v-text-field>
          </v-col>
      </v-row>

      <!-- sort by -->
      <v-row>
          <v-col cols="12">
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      text
                      class="blue-grey--text"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="sortBy('class')"
                  >
                      <v-icon small left>mdi-google-classroom</v-icon>
                      <span>class</span>
                  </v-btn>
                  </template>
                  <span>'class'로 정렬하기</span>
              </v-tooltip>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      text
                      class="blue-grey--text"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="sortBy('hangeul')"
                  >
                      <v-icon small left>mdi-tag-outline</v-icon>
                      <span>hangeul</span>
                  </v-btn>
                  </template>
                  <span>'hangeul'로 정렬하기</span>
              </v-tooltip>
          </v-col>
      </v-row>

      <!-- items -->
      <v-card class="mx-3" flat v-for="item in filteredItems" :key="item.id">
          <v-row :class="`item ${item.nodeDescription.class}`">
              <v-col
                  cols="3"
                  sm="2"
                  md="2"
                  lg="1"
              >
                  <div>{{ item.nodeDescription.class }}</div>
                  <div class="text-caption grey--text">{{ item.nodeDescription.groupName }}</div>
              </v-col>            
              <v-col
                  cols="9"
                  sm="7"
                  md="3"
                  lg="3"
              >
                  <router-link :to="{ name: 'SingleItem', params: { timestamp: item.timestamp } }">
                  {{ item.nodeDescription.hangeul }}
                  </router-link>
                  <div class="text-caption grey--text">{{ item.nodeDescription.english }}</div>
              </v-col>
              <v-col
                  cols="3"
                  sm="3"
                  md="2"
                  lg="2"
              >
                  <div>{{ item.nodeDescription.hanja }}</div>
                  <div class="text-caption grey--text">{{ item.birthYear }}~{{ item.deathYear }}</div>
              </v-col>
              <v-col
                  cols="8"
                  sm="9"
                  md="4"
                  lg="5"
              >
                  <div class="text-truncate">
                  {{ item.content }}
                  </div>
                  <div>
                  <span class="text-caption grey--text">{{ item.nodeDescription.infoUrl }}</span>
                  <v-btn class="grey--text" text small :href="item.nodeDescription.infoUrl" target="_blank">
                      <v-icon small class="blue-grey--text text--lighten-3">mdi-open-in-new</v-icon>
                  </v-btn>
                  </div>
              </v-col>
              <v-col
                cols="1"
                sm="3"
                md="1"
                lg="1"
              >
                <div class="text-caption blue-grey--text">{{ item.user.name }}</div>
              </v-col>
          </v-row>
          <v-divider></v-divider>
      </v-card>

      <!-- items -->
      <!-- <v-row>
        <v-col cols="12">
          <v-card flat v-for="item in filteredItems" :key="item.id">
            <v-row :class="`item ${item.nodeDescription.class}`">
              <v-col cols="1">
                <div>{{ item.nodeDescription.class }}</div>
                <div class="text-caption grey--text">{{ item.nodeDescription.groupName }}</div>
              </v-col>            
              <v-col cols="3">
                <router-link :to="{ name: 'SingleItem', params: { timestamp: item.timestamp } }">
                  {{ item.nodeDescription.hangeul }}
                </router-link>
                <div class="text-caption grey--text">{{ item.nodeDescription.english }}</div>
              </v-col>
              <v-col cols="2">
                <div>{{ item.nodeDescription.hanja }}</div>
                <div class="text-caption grey--text">{{ item.birthYear }}~{{ item.deathYear }}</div>
              </v-col>
              <v-col cols="5">
                <div class="text-truncate">
                  {{ item.content }}
                </div>
                <div>
                  <span class="text-caption grey--text">{{ item.nodeDescription.infoUrl }}</span>
                  <v-btn class="grey--text" text small :href="item.nodeDescription.infoUrl" target="_blank">
                    <v-icon small class="blue-grey--text text--lighten-3">mdi-open-in-new</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="1">
                <div class="text-caption blue-grey--text">{{ item.user.name }}</div> -->
                <!-- <router-link :to="{ name: 'EditItem', params: { timestamp: item.timestamp } }">
                  <v-btn icon>
                    <v-icon class="blue-grey--text">mdi-pencil</v-icon>
                  </v-btn>
                </router-link> -->
                <!-- <v-btn class="delete" icon @click="deleteItem(item.id)">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn> -->
              <!-- </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-card>
        </v-col>
      </v-row> -->
    </v-container>
  </div>
</template>

<script>
import { db } from '../firebase/init'

export default {
  name: 'Home',
  data () {
    return {
      search: '',
      items: []
    }
  },
  methods: {
    sortBy(prop){
      this.items.sort((a, b) => a.nodeDescription[prop] < b.nodeDescription[prop] ? -1 : 1)
    },
    deleteItem(id){
      db.collection('items').doc(id).delete().then(() => {
        this.items = this.items.filter(item => {
          return item.id != id;
        })
      })
    },
  },
  computed: {
    filteredItems(){
      return this.items.filter(item => {
        return item.nodeDescription.id.match(this.search);
      })
    }
  },
  mounted(){
    db.collection('items').orderBy('timestamp', 'asc').get().then(snapshot => {
      snapshot.forEach(doc => {
        let item = doc.data();
        item.id = doc.id;
        this.items.push(item);
      })
    })
  }
}
</script>

<style scoped>
.item.Actor {
  border-left: 4px solid #F48FB1;
}
.item.Event {
  border-left: 4px solid #9FA8DA;
}
.item.Place {
  border-left: 4px solid #CE93D8;
}
.item.Record {
  border-left: 4px solid #80CBC4;
}
.item.Object {
  border-left: 4px solid #BCAAA4;
}
.item.Concept {
  border-left: 4px solid #FFF59D;
}
.item.Story {
  border-left: 4px solid #CE93D8;
}
.item.Food {
  border-left: 4px solid #C5E1A5;
}
.delete {
  position: absolute;
  bottom: 4px;
  right: 4px;
  cursor: pointer;
  color: #aaa;
  font-size: 1.2em;

}
</style>